import { SuperAdminService } from "services/superAdminService";

class SupportSAService extends SuperAdminService<any> {
  constructor() {
    super("supports");
  }  
}
export default new SupportSAService();
